var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 87,
    viewBox: "0 0 118 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.04 60.9776C107.948 47.0009 91.9372 30.8112 69.2905 20.4911C46.6437 10.171 23.9239 8.69629 11.3443 15.5225L7.62643 13.8326L2.93785 24.1167C-4.11935 39.603 14.1354 63.0949 43.7165 76.5775C73.2975 90.06 103.007 88.4423 110.05 72.9688L114.739 62.6847L111.04 60.9776Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4006 66.2906C77.9828 79.7769 107.688 78.1533 114.749 62.6644C121.811 47.1754 103.554 23.6862 73.9718 10.2C44.3896 -3.2862 14.6841 -1.66252 7.62284 13.8265C0.56158 29.3154 18.8184 52.8044 48.4006 66.2906Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.541 57.2178C75.865 67.8509 98.8456 67.5369 103.87 56.5162C108.894 45.4956 94.0592 27.9417 70.7352 17.3086C47.4113 6.67544 24.4306 6.98963 19.4064 18.0103C14.3822 29.0309 29.2171 46.5847 52.541 57.2178Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin1);
export default __webpack_public_path__ + "static/media/coin1.a0fc84f10a6982aa1fa4c92e892a43e6.svg";
export { ForwardRef as ReactComponent };